module.exports = __webpack_public_path__ + "img/aiis.aa3a5c2a.png";